import styled from 'styled-components';
import { ThemeColours } from '../common/styles/ThemeColours';
import { Breakpoint, FontSize, FontWeight } from '../common/styles/constants';
import Bowel from './DogFood.svg';

export const generateBackground = () => {
  const r = Math.floor(40 * Math.random()) + 210;
  const g = Math.floor(40 * Math.random()) + 210;

  return `rgb(${r}, ${g}, 250)`;
};

export const DogFoodWrapper = styled.div<{ expanded: boolean; bgColor: string }>`
  background-color: ${props => props.bgColor};
  border: 1px solid black;
  border-radius: 8px;
  bottom: 10px;
  height: fit-content;
  max-height: 800px;
  max-width: 800px;
  overflow-y: ${props => (props.expanded ? 'scroll' : 'hidden')};
  padding: 16px;
  position: fixed;
  right: 10px;
  width: fit-content;
  z-index: 400;

  ${Breakpoint.MEDIUM} {
    bottom: unset;
    left: 50px;
    overflow-x: default;
    right: unset;
    top: 105px;
  }
`;

export const FlagDetail = styled.div`
  border-bottom: 1px solid gray;
`;

export const FlagHeading = styled.h3`
  color: ${ThemeColours.black};
  font-size: ${FontSize.LARGE}
  font-weight: ${FontWeight.REGULAR};
  line-height: 24px;
  margin: 0 8px;
  padding: 8px 0px;
`;

export const FlagSubHeading = styled.h4`
  color: ${ThemeColours.mono600};
  font-size: ${FontSize.REGULAR}
  font-weight: ${FontWeight.LIGHT};
  line-height: 24px;
  margin: 0 8px;
  padding: 4px 0px;
`;

export const StyledBowl = styled(Bowel)`
  color: ${ThemeColours.black};
  cursor: pointer;
  height: auto;
  width: 25px;

  ${Breakpoint.MEDIUM} {
    width: 50px;
  }
`;

export const StatusIndicator = styled.span<{ enabled: boolean }>`
  color: ${props => (props.enabled ? 'green' : 'red')};
`;

export const FlagDescription = styled.div`
  color: ${ThemeColours.black};
  font-size: ${FontSize.REGULAR};
  padding: 4px 8px;
`;
